'use client'

import { useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import {
  selfServiceViewScreenEvent,
  clickEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import TrackingJourneySummaryModal from '../TrackingJourneySummaryModal'

type Props = ConversationActionProps

const TrackShipment = ({ title, primary, size, theme, inverse }: Props) => {
  const { track } = useTracking()
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id
  const shipmentId = conversation?.transaction?.shipment?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  const trackButtonClick = () => {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'track_parcel',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const trackModalScreen = () => {
    if (!transactionId) return

    track(
      selfServiceViewScreenEvent({
        screen: 'track_shipment_view',
        transactionId,
        variant: 'modal',
      }),
    )
  }

  const handleModalOpen = () => {
    trackButtonClick()
    trackModalScreen()

    setIsModalOpen(true)
  }

  const handleModalClose = () => setIsModalOpen(false)

  if (!transactionId) return null

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        onClick={handleModalOpen}
      />
      <TrackingJourneySummaryModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        transactionId={transactionId}
        shipmentId={shipmentId}
      />
    </>
  )
}

export default TrackShipment
